import { Text, Link } from '@belong/ui';
import { clsx } from 'clsx';
import { SeoHint } from 'src/features/home-page/components/seo-hint/seo-hint';
import { HOME_PAGE_STRINGS } from 'src/features/home-page/home-page.strings';
import css from './hero.module.css';

export function Hero() {
  return (
    <div className="isolate">
      <SeoHint />
      <div className="xl:max-w-container-xl relative w-full lg:container">
        <div className="pb-2xl pt-xl md:pt-3xl relative z-20">
          <div className={clsx('mb-sm mx-auto text-center', css.title)}>
            <Text
              as="h2"
              variant="h1"
              fontWeight="semibold"
              className="text-white"
            >
              {HOME_PAGE_STRINGS['header.title']}
            </Text>
          </div>
          <div
            className={clsx(
              'mb-xl mx-auto text-center text-white',
              css.subtitle,
            )}
          >
            <div className="contents sm:hidden">
              <Text variant="h3">
                {HOME_PAGE_STRINGS['header.subtitle']}
                <br />
                {HOME_PAGE_STRINGS['header.subtitle2']}
              </Text>
            </div>
            <div className="hidden sm:contents">
              <Text variant="h3">
                {HOME_PAGE_STRINGS['header.subtitle']}{' '}
                {HOME_PAGE_STRINGS['header.subtitle2']}
              </Text>
            </div>
          </div>
          <div className="gap-xs md:gap-sm container flex w-full justify-center">
            <div className="flex-1 md:flex-none">
              <div className="contents md:hidden">
                <Link
                  data-testid="homeowners-cta"
                  href="/homeowners"
                  variant="solid"
                  size="fluid"
                >
                  {HOME_PAGE_STRINGS['header.ownersCta']}
                </Link>
              </div>
              <div className="hidden md:contents">
                <Link
                  data-testid="homeowners-cta"
                  href="/homeowners"
                  variant="solid"
                  size="large"
                >
                  {HOME_PAGE_STRINGS['header.ownersCta']}
                </Link>
              </div>
            </div>
            <div className="flex-1 text-center md:flex-none">
              <div className="contents md:hidden">
                <Link href="/homes" variant="solid" size="fluid">
                  {HOME_PAGE_STRINGS['header.rentersCta']}
                </Link>
              </div>
              <div className="hidden md:contents">
                <Link href="/homes" variant="solid" size="large">
                  {HOME_PAGE_STRINGS['header.rentersCta']}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
